// services/contratApi.js
import { apiSlice } from "services/apiSlice";

export const contratApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContrat: builder.query({
      query: (companyId) => `signatures/companyId/${companyId}`,
      providesTags: ["CONTRAT"],
    }),
  }),
  overrideExisting: false,
});

// Export des hooks
export const { useGetContratQuery } = contratApi;
